<ng-container *ngIf="!clipLoading; else loading">
  <button
    mat-button
    color="success"
    type="button"
    (click)="downloadClip()"
    [disabled]="invalid || errorTimer"
  >
    <sn-icon>cloud_download</sn-icon>{{ 'map.downloadVideo.downloadClip' | t }}
  </button> </ng-container
><button mat-button color="warn" type="button" (click)="cancelDownload()" *ngIf="isDownloading">
  <sn-icon>cancel</sn-icon>{{ 'common.cancelDownload' | t }}
</button>
<ng-template #loading>
  <mat-progress-bar
    color="accent"
    [mode]="percentDone ? 'determinate' : 'indeterminate'"
    [value]="percentDone"
  >
  </mat-progress-bar>
  <div class="remainingTime" *ngIf="secondsLeft">
    {{ 'map.downloadVideo.estimatedTimeRemaining' | t }} {{ secondsLeft | snDateDuration }}
  </div>
  <div class="fileSize" *ngIf="fileSize">
    {{ downloadedSize | snFilesize }} / {{ fileSize | snFilesize }}
  </div>
</ng-template>
